'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EVENT_GA4 = exports.EVENT_GA4 = 'eventga4';
var EVENT_GA4_ECOMMERCE = exports.EVENT_GA4_ECOMMERCE = 'eventga4_ecommerce';
var ECOMMERCE_EVENT = exports.ECOMMERCE_EVENT = 'ecommerce.js';
var ECOMMERCE_BRAND = exports.ECOMMERCE_BRAND = 'Spotahome';

var ECOMMERCE_ACTIONS = exports.ECOMMERCE_ACTIONS = {
  view_item_list: 'view_item_list',
  select_item: 'select_item',
  view_item: 'view_item',
  add_to_cart: 'add_to_cart',
  checkout_option: 'checkout_option'
};

var ECOMMERCE_ACTIONS_CHECKOUT = exports.ECOMMERCE_ACTIONS_CHECKOUT = {
  1: 'book_now',
  2: 'begin_checkout',
  3: 'add_personal_info',
  4: 'add_shipping_info',
  5: 'add_payment_info'
};
//# sourceMappingURL=constants.js.map